// 03/11/2026 (registre n° 38) : Paramètres > Message laissé — modèle commun du mail « Appel fait ».
// Enregistré pour tous les utilisateurs (service Demandes reçues), repris à l'ouverture de la fenêtre d'envoi.
import React from "react";
import { Button, FormGroup, ControlLabel, FormControl, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { lireModele, enregistrerModele } from "../../store/external/modeles";

const CLE = "message_laisse";
const MAX = 4000;

export default class CallDoneTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = { texte: "", defaut: "", info: null, loading: true, saving: false, erreur: null, modifie: false };
  }

  componentDidMount() {
    this.charger();
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  charger = () => {
    this.setState({ loading: true, erreur: null });
    lireModele(CLE)
      .then((j) => {
        if (this.unmounted) return;
        this.setState({ texte: j.texte || "", defaut: j.defaut || "", info: j, loading: false, modifie: false });
      })
      .catch((e) => {
        if (this.unmounted) return;
        this.setState({ loading: false, erreur: "Modèle illisible (" + e.message + "). Recharger la page." });
      });
  };

  enregistrer = () => {
    const texte = this.state.texte.trim();
    if (!texte) { toast.error("Le texte ne peut pas être vide"); return; }
    this.setState({ saving: true });
    enregistrerModele(CLE, texte)
      .then((j) => {
        if (this.unmounted) return;
        toast.success("Modèle enregistré — utilisé pour les prochains envois");
        this.setState({ texte: j.texte, defaut: j.defaut || this.state.defaut, info: j, saving: false, modifie: false });
      })
      .catch((e) => {
        if (this.unmounted) return;
        toast.error("Enregistrement impossible : " + e.message);
        this.setState({ saving: false });
      });
  };

  render() {
    const { texte, defaut, info, loading, saving, erreur, modifie } = this.state;
    if (loading) return <div style={{ padding: 20, color: "#5d6b7a" }}>Chargement du modèle…</div>;
    if (erreur) return <div className="alert alert-warning" style={{ marginTop: 12 }}>{erreur}</div>;
    const derniere = info && info.modifie_par
      ? "par " + info.modifie_par + " le " + info.modifie_le
      : "aucune (texte d'origine)";
    return (
      <Row style={{ marginTop: 14 }}>
        <Col md={7}>
          <p style={{ color: "#3d4a57" }}>
            Texte proposé quand on clique sur <b>« Appel fait »</b>. Il est enregistré pour <b>tous les utilisateurs</b> et
            repris à chaque envoi ; il reste modifiable au cas par cas dans la fenêtre d'envoi.
          </p>
          <FormGroup controlId="atis-modele-message-laisse">
            <ControlLabel>Texte du mail envoyé au client</ControlLabel>
            <FormControl
              componentClass="textarea"
              rows="9"
              maxLength={MAX}
              value={texte}
              onChange={(e) => this.setState({ texte: e.target.value, modifie: true })}
            />
            <small style={{ color: "#5d6b7a" }}>
              {texte.length} caractères · Le n° de la demande et son intitulé sont ajoutés automatiquement en tête du mail.
            </small>
          </FormGroup>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
            <Button bsStyle="primary" disabled={saving || !texte.trim() || !modifie} onClick={this.enregistrer}>
              <span className="fa fa-save" />&nbsp;{saving ? "Enregistrement…" : "Enregistrer le modèle"}
            </Button>
            <Button disabled={saving || texte === defaut} onClick={() => this.setState({ texte: defaut, modifie: true })}>
              Rétablir le texte d'origine
            </Button>
            {modifie ? <span style={{ color: "#A84A00", fontWeight: 600 }}>Modifié, non enregistré</span> : null}
          </div>
          <p style={{ color: "#5d6b7a", fontSize: 12.5, borderTop: "1px solid #E3E8EE", paddingTop: 8, marginTop: 14 }}>
            Dernière modification : {derniere}
          </p>
        </Col>
        <Col md={5}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#5d6b7a", textTransform: "uppercase", marginBottom: 6 }}>
            Aperçu du mail reçu par le client
          </div>
          <div style={{ border: "1px solid #E3E8EE", borderRadius: 8, overflow: "hidden" }}>
            <div style={{ background: "#fafbfc", borderBottom: "1px solid #E3E8EE", padding: "8px 12px", fontSize: 12.5, color: "#3d4a57" }}>
              <div><b>Objet :</b> [NOM DU CLIENT] MESSAGE LAISSÉ</div>
            </div>
            <div style={{ padding: "12px 14px", fontSize: 13.5, lineHeight: 1.5 }}>
              <h4 style={{ marginTop: 0 }}>Message laissé</h4>
              <p><b>Demande n° [n°] :</b> [intitulé de la demande]</p>
              <p style={{ whiteSpace: "pre-line" }}>{texte}</p>
              <p style={{ marginTop: 16, fontSize: 12.5 }}>
                --<br />ATIS SYSTEM<br />Tél. 04 72 45 96 03 · sav@atissystem.com<br />Suivi de vos demandes : app.atissystem.fr
              </p>
              <p style={{ color: "#777", fontSize: 11 }}>
                Message automatique envoyé par l'application d'interventions d'ATIS SYSTEM. Merci de ne pas répondre à ce
                message : pour toute question, écrivez à sav@atissystem.com.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/CallDoneTemplate.js